import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import './HeaderBar.css';

class HeaderBar extends Component {

    render() {

        return (

            <ul className="nav-menu">
                <li className="menu-active"><a href='#home_sec'><FormattedMessage id='about_us'
                                      description='say hello to Howard.'
                                      defaultMessage='{about_us_str}'
                                      values={{about_us_str: this.props.about_us,}}
                /></a></li>
                <li className="menu-active"><a href='#user_cases_sec'><FormattedMessage id='user_cases'
                                      description='say hello to Howard.'
                                      defaultMessage='{user_cases_str}'
                                      values={{user_cases_str: this.props.user_cases,}}
                /></a></li>
                <li className="menu-active"><a href='#services_sec'><FormattedMessage id='services'
                                                                                        description='say hello to Howard.'
                                                                                        defaultMessage='{services_str}'
                                                                                        values={{services_str: this.props.services,}}
                /></a></li>
                <li className="menu-active"><a href='#contact_us_sec'><FormattedMessage id='contact_us'
                                      description='say hello to Howard.'
                                      defaultMessage='{contact_us_str}'
                                      values={{contact_us_str: this.props.contact_us,}}
                /></a></li>
                <li className="menu-has-children"><a href="/en">Language</a>
                    <ul>
                        <li><a href="/en">English</a></li>
                        <li><a href="/hk">繁体中文</a></li>
                        <li><a href="/cn">简体中文</a></li>
                    </ul>
                </li>
            </ul>
        );
    }
}

export default HeaderBar;




// WEBPACK FOOTER //
// ./src/components/HeaderBar.js